// extracted by mini-css-extract-plugin
export default {"mapWrapper":"map_mapWrapper__WOZCe"};